export default "__VITE_ASSET__ad95138b__"